import { render, staticRenderFns } from "./JwlSubmitRow.vue?vue&type=template&id=42f7ca54&"
import script from "./JwlSubmitRow.vue?vue&type=script&lang=ts&"
export * from "./JwlSubmitRow.vue?vue&type=script&lang=ts&"
import style0 from "./JwlSubmitRow.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports